import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import SweetAlert2 from "react-sweetalert2";
import * as actions from "../redux/PlatfromSettingAction";
import { Switch } from "antd";
import { UIWordingManage } from "./UIWordingManage";
import { LOCALES } from "../../../i18n/locales";

export const UIWordingList = () => {
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const [languageShow, setLanguageShow] = useState();
  const dispatch = useDispatch();
  const platformSettingState = useSelector(
    ({ platformSetting }) => platformSetting,
    shallowEqual
  );
  useEffect(() => {
    const queryParams = {
      action: "uiwordinglist",
    };
    dispatch(actions.getUIWording(queryParams));
  }, []);

  return (
    <div style={{ width: "95%", margin: "5px auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <UIWordingManage
        setSwalProps={setSwalProps}
        setLanguageShow={setLanguageShow}
        languageShow={languageShow}
      />
      <div className="mb-4 d-flex align-items-center justify-content-between">
        <h2 className="m-0 p-0">{intl.formatMessage({ id: "uiWording" })}</h2>
        {platformSettingState.uiWording?.uiWordingLists &&
          platformSettingState.uiWording.uiWordingLists.length < 5 && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                const wording =
                  platformSettingState.uiWording?.uiWordingLists?.find(
                    (wording) => wording.languagecode === LOCALES.ENGLISH
                  );
                setLanguageShow(
                  wording ?? {
                    languagecode: LOCALES.ENGLISH,
                    content: "",
                    projectid: "",
                  }
                );
              }}
            >
              {intl.formatMessage({ id: "create" })}
            </button>
          )}
      </div>
      <div className="member-container">
        <div className="table-responsive">
          <table style={{ minWidth: "100%" }}>
            <thead className="member-header1">
              <tr className="member-row1">
                <th className="member-cell hide-on-mobile">
                  {intl.formatMessage({ id: "no" })}
                </th>
                <th className="member-cell text-start">
                  {intl.formatMessage({ id: "language" })}
                </th>
                <th className="member-cell  text-start">
                  {intl.formatMessage({ id: "description" })}
                </th>
                <th className="member-cell  text-start">
                  {intl.formatMessage({ id: "content" })}
                </th>
                <th className="member-cell  text-end">
                  {intl.formatMessage({ id: "action" })}
                </th>
              </tr>
            </thead>
            <tbody className="member-body">
              {platformSettingState.uiWording?.uiWordingLists &&
              platformSettingState.uiWording.uiWordingLists.length > 0 ? (
                platformSettingState.uiWording.uiWordingLists.map(
                  (wording, index) => (
                    <tr key={index} className="member-row1">
                      <td className="member-cell hide-on-mobile">
                        {index + 1}
                      </td>
                      <td className="member-cell text-nowrap text-start">
                        {wording.languagecode}
                      </td>
                      <td className="member-cell text-nowrap  text-start">
                        {wording.description}
                      </td>
                      <td className="member-cell text-nowrap  text-start">
                        {wording.content}
                      </td>
                      <td className="member-cell text-nowrap  text-end">
                        <button
                          className="btn btn-primary me-1"
                          style={{
                            backgroundColor: "#00FFFF",
                            borderColor: "#00FFFF",
                            color: "black",
                          }}
                          onClick={() => setLanguageShow(wording)}
                        >
                          <i className="bi bi-pencil-fill" />
                        </button>
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td colSpan="4">
                    <div className="no-record-wrapper">
                      <i className="bi bi-search fs-1 mb-3" />
                      <div className="text-font2">
                        {intl.formatMessage({ id: "noRecordFound" })}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
